import React from 'react';
import Box, { BoxProps } from './Box';
import styled from 'styled-components';
import { system, extractSysProps } from './system';

// Replicates molekule Container:
//   margin-left/right: auto
//   width: 100%
//   max-width: fluid ? '100%' : `${maxWidth || theme.gridWidth}px`
//   padding-left/right: gutter ?? theme.gridGutter (px)
//
// Props: fluid (bool), maxWidth (number, overrides theme.gridWidth), gutter (number)
// System props also accepted and layered on top.

export type ContainerProps = BoxProps & {
  fluid?: boolean;
  maxWidth?: number;
  gutter?: number;
};

interface StyledContainerInternalProps {
  $fluid?: boolean;
  $maxWidth?: number;
  $gutter?: number;
  $sys: Record<string, any>;
  [key: string]: any;
}

const StyledContainer = styled.div<StyledContainerInternalProps>`
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  max-width: ${(p: any) =>
    p.$fluid
      ? '100%'
      : `${p.$maxWidth || (p.theme && p.theme.gridWidth) || 1200}px`};
  padding-left: ${(p: any) =>
    p.$gutter !== undefined
      ? p.$gutter
      : (p.theme && p.theme.gridGutter) || 16}px;
  padding-right: ${(p: any) =>
    p.$gutter !== undefined
      ? p.$gutter
      : (p.theme && p.theme.gridGutter) || 16}px;
  ${(p: any) => system(p.$sys, p.theme)}
`;

const Container: React.FC<ContainerProps> = ({
  fluid,
  maxWidth,
  gutter,
  children,
  ...props
}) => {
  const { sys, rest } = extractSysProps(props);

  return (
    <StyledContainer
      $fluid={fluid}
      $maxWidth={maxWidth}
      $gutter={gutter}
      $sys={sys}
      {...rest}
    >
      {children}
    </StyledContainer>
  );
};

Container.displayName = 'Container';

export default Container;
